import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { StatusUsuario } from '@core/models/status-usuario';

const  baseRef = 'contato-pessoa';
const route = {
  listar: `${baseRef}`,
  excluir: (id: number) => `${baseRef}/${id}`
}

@Injectable({
  providedIn: 'root'
})
export class ContatoPessoaService {

  constructor(private apiService: ApiService) {

  }

  excluir(id: number) {
    return this.apiService.delete<any[]>(route.excluir(id));
  }
}
